import React, { FC, useEffect, useRef, useState } from "react";
import { useParams, useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { initReactI18next, useTranslation } from "react-i18next";
import Recaptcha from "../../modules/Recaptcha/Recaptchav2";

const Contact = ({ dispatch_post_contact }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const ref = useRef();
  const [t, i18n] = useTranslation();

  const [mail_address, set_mail_address] = useState("");
  const [full_name, set_full_name] = useState("");
  const [phone_number, set_phone_number] = useState("");
  const [message, set_message] = useState("");
  const [recaptcha, set_recaptcha] = useState("");

  useEffect(() => {}, []);
  return (
    <div class="d-flex flex-column justify-content-between bg-light ">
      <header className="py-3 mb-auto bg-brand">
        <div className="container d-flex justify-content-between align-items-center">
          <a
            className="text-white"
            href="javascript:history.back();"
            onClick={(e) => {
              e.preventDefault();
              history.goBack();

              window.scroll(0, 0);
            }}
          >
            <i className="fas fa-angle-left fa-fw" />
            {t("戻る")}
          </a>
          <h1 className="haederbar-title text-white">{t("お問い合わせ")}</h1>
          <a
            href="index.html"
            onClick={(e) => {
              e.preventDefault();
              history.goBack();
              window.scroll(0, 0);
            }}
          >
            <img src="images/brand-white.svg" height={28} alt="SC WORLD EXCHANGE" />
          </a>
        </div>
      </header>
      <main role="main" className="main header-fixed">
        <div className="container">
          <section className="section create-section mx-auto" style={{padding:"1rem"}}>
            <form action="sending.html" method="post">
              <div className="row">
                <div className="form-group col-lg-6">
                  <label htmlFor="nm"> {t("お名前")}</label>
                  <input
                    type="text"
                    id="nm"
                    className="form-control"
                    placeholder={t("お名前")}
                    required
                    // autofocus
                    value={full_name}
                    onChange={(e) => {
                      set_full_name(e.target.value);
                    }}
                  />
                </div>
                <div className="form-group col-lg-6">
                  <label htmlFor="ml">{t("メールアドレス")}</label>
                  <input
                    type="email"
                    id="ml"
                    className="form-control"
                    placeholder={t("メールアドレス")}
                    required
                    value={mail_address}
                    onChange={(e) => {
                      set_mail_address(e.target.value);
                    }}
                  />
                </div>
                <div className="form-group col-lg-6">
                  <label htmlFor="phone">{t("電話番号")}</label>
                  <input
                    type="tel"
                    id="phone"
                    className="form-control"
                    placeholder={t("電話番号")}
                    required
                    value={phone_number}
                    onChange={(e) => {
                      set_phone_number(e.target.value);
                    }}
                  />
                </div>
                <div className="form-group col-lg-6">
              </div>

                {/* <div className="form-group col-lg-6">
                  <label>Are you a member?</label>
                  <div className>
                    <div className="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        id="n"
                        name="member"
                        className="custom-control-input"
                        defaultChecked="checked"
                      />
                      <label className="custom-control-label" htmlFor="n">
                        No
                      </label>
                    </div>
                    <div className="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        id="y"
                        name="member"
                        className="custom-control-input"
                      />
                      <label className="custom-control-label" htmlFor="y">
                        YES
                      </label>
                    </div>
                  </div>
                </div> */}
                {/* <div className="form-group col-12">
                  <label htmlFor="nm">Contact type</label>
                  <select className="form-control" required>
                    <option>About our exchange</option>
                    <option>About listing application</option>
                    <option>About Wallet registration</option>
                    <option>About current campaigns</option>
                    <option>About Join Us</option>
                    <option>Others</option>
                  </select>
                </div> */}
                <div className="form-group col-12">
                  <label htmlFor="msg">{t("お問い合わせ内容")}</label>
                  <textarea
                    id="msg"
                    className="form-control"
                    rows={8}
                    placeholder={t("お問い合わせ内容")}
                    required
                    defaultValue={""}
                    value={message}
                    onChange={(e) => {
                      set_message(e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="text-center mt-4">
              <Recaptcha set_recaptcha={set_recaptcha} action="login" />

                <button
                  type="submit"
                  className="btn btn-primary"
                  onClick={(e) => {
                    e.preventDefault();
                    dispatch_post_contact(
                      {
                        recaptcha,
                        mail_address,
                        full_name,
                        phone_number,
                        message,
                      },
                      () => {
                        history.push({
                          pathname: `/sending`,
                        });
                        window.scroll(0, 0);
                      }
                    );
                  }}
                >
                  {t("送信")}
                </button>
              </div>
            </form>
          </section>
        </div>
      </main>
    </div>
  );
};

export default Contact;
